import axios from "axios";

export const fetchLearningPath = async (uid) => {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/learning-paths/${uid}`,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return await response.data;
};

export async function fetchLearningPathProgress(uid) {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/learning-paths/${uid}/courses`,
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    return await response.data;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error(
        "Error fetching learning path courses:",
        error.response.status,
        error.response.data
      );
      throw new Error(
        `Failed to fetch learning path courses: ${error.response.status}`
      );
    } else if (error.request) {
      // The request was made but no response was received
      console.error("No response received:", error.request);
      throw new Error("No response received from server");
    } else {
      // Something happened in setting up the request
      console.error("Error setting up request:", error.message);
      throw new Error("Failed to make request");
    }
  }
}
export const fetchLearningPathLessons = async (learningPathId) => {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/learning-paths/${learningPathId}/lessons`,
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
    return await response.data;
  } catch (error) {
    if (error.response) {
      // Server responded with error status
      console.error(
        "Error fetching learning path lessons:",
        error.response.status,
        error.response.data
      );
      throw new Error(
        `Failed to fetch learning path lessons: ${error.response.status}`
      );
    } else if (error.request) {
      // Request made but no response received
      console.error("No response received:", error.request);
      throw new Error("No response received from server");
    } else {
      // Error in request setup
      console.error("Error setting up request:", error.message);
      throw new Error("Failed to make request");
    }
  }
};
